export function loadUsercentrics(): any {
  return require('@usercentrics/cmp-browser-sdk').default;
}
